import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--upload" icon='upload'>{ children ? children : 'Upload' }</Button>
}